/*
Suresh Peddavoora 12/22/2022 3075154998 Added Accordions for Preprocessor Table
Akhila 12/23/2022 3075154998 Added PopUp and field in PopUp in Add Action button
Akhila 12/26/2022 3075154998 Added classes for header
Akhila 12/28/2022 3075154998 Added Add  Action popUp and Added Fields
Sohel 12/29/2022 3075154998 Action Table Changes
Sohel 01/23/2023 3075154998 Added code based on Condition
Sohel 04/19/2023 2698964415 Added Error Record in Exports
Akhila 04/24/2023 3075154998 bug fixed and prepoulated data
*/
import {Button, Typography} from '@material-ui/core';
import React, {useState} from 'react';
import reusableInputStyles from '../../../../../components/InputStyles';
import {Form, Formik} from 'formik';
import AddIcon from '@material-ui/icons/Add';
import DMREditTableData from './DMREditTableData';
import DialogBox from '../../../../../components/DialogBox';
import ActionAddRule from './ActionAddRule/index';

const DMRProcessor = ({
  setActionFormData,
  actionformData,
  isActionEditMode,
  setIsActionEditMode,
  setActionRowData,
  setActionOldRuleCode,
  conditionalProps,
  actionRowData,
  actionDeleteIdsRef,
  managerRecordGroup,
  exportManagerRecord,
}) => {
  const classes = reusableInputStyles();
  const isDataTransformation = ['Y', true]?.includes(conditionalProps?.value?.isDataTransformation) ?
    true :
    false;
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setIsActionEditMode(false);
  };

  return (
    <>
      <Formik>
        {(props) => {
          const {} = props;
          return (
            <Form>
              <div className="table-header table-card-header new-standard-textfields  justify-content-between">
                <Typography variant="h3">Actions: </Typography>
                <Button
                  variant="outlined"
                  className={`search-btn ${classes.buttonRoot}`}
                  startIcon={<AddIcon />}
                  disabled={isDataTransformation}
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  Add Action
                </Button>
              </div>
              <DMREditTableData
                setActionFormData={setActionFormData}
                actionformData={actionformData}
                isActionEditMode={isActionEditMode}
                setIsActionEditMode={setIsActionEditMode}
                setActionRowData={setActionRowData}
                conditionalProps={conditionalProps}
                actionDeleteIdsRef={actionDeleteIdsRef}
                exportManagerRecord={exportManagerRecord}
              />
              {/* <div className="d-flex justify-content-center align-items-center mt-4">
                <Button
                  variant="outlined"
                  type="button"
                  className={`reset-btn mx-1 ${classes.buttonRoot}`}
                >
                  {"Cancel"}
                </Button>
                <Button
                  variant="outlined"
                  type="button"
                  className={`search-btn mx-1 ${classes.buttonRoot}`}
                >
                  {"Save"}
                </Button>
              </div> */}
            </Form>
          );
        }}
      </Formik>

      <DialogBox
        open={open || isActionEditMode}
        dialogClose={handleClose}
        hideFooter={true}
        maxWidth={'xl'}
        title="Add Action"
      >
        <ActionAddRule
          setActionFormData={setActionFormData}
          isActionEditMode={isActionEditMode}
          setIsActionEditMode={setIsActionEditMode}
          actionformData={actionformData}
          setActionRowData={setActionRowData}
          setOpen={setOpen}
          handleClose={handleClose}
          conditionalProps={conditionalProps}
          actionRowData={actionRowData}
          managerRecordGroup={managerRecordGroup}
        />
      </DialogBox>
    </>
  );
};

export default React.memo(DMRProcessor);
